module.exports = JSON.stringify;